import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { EMPTY, Observable, Subscription, catchError, concat, filter, first, of, switchMap, take, throwError } from 'rxjs';
import { TokenService } from '../services/token.service';
import { AuthState } from '../Auth/state';
import { debug } from 'ngxtension/debug';


const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  userSub: Subscription;

  private readonly authentication = inject(AuthState);


  private exclusionList: string[] = [
    '/auth/login',
    '/auth/token/refresh',

  ];



  constructor() {

   }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const isInExclusionList = this.exclusionList.some(url => req.url.includes(url));

    if(isInExclusionList)
    {
      return next.handle(req.clone({
        withCredentials: true
    }));
    }

    const authHeader = req.headers.get('Authorization');
    if (authHeader) {
      const clonedReq = req.clone({
        withCredentials: true,
        headers: req.headers });

      return next.handle(clonedReq);
    }

    let authReq = req;
    if (this.authentication.state.accessToken()) {
      authReq = req.clone({withCredentials:true})
    }
    return next.handle(authReq).pipe(catchError((error) => {
      if (error instanceof HttpErrorResponse) {
      const httpErrorCode: number = error['status'];
      switch (httpErrorCode) {
          case 404:
            return throwError(() => new Error(`${error}`));
          case 401:
            return this.handle401Error(authReq, next);
          default:
            return throwError(() => new Error(`${error}`));
         }
         } else {
           return throwError(() => new Error(`${error}`));
         }
     }));
  }

  private handle401Error(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.authentication.state.refreshStatus$.pipe(
      take(1),
      debug("401 error"),
      switchMap(refreshStatus => {
        switch (refreshStatus) {
          case 'SUCCESSFUL':
            return this.handleRequestWithToken(request,next);
          case 'FAILED':
            return throwError(() => Error('Token refresh failed'));
          case 'NOT STARTED':
            {
              return this.authentication.refreshToken.pipe(debug("Starting Refresh"),
              switchMap(({refreshStatus}) => {
                if (refreshStatus === 'SUCCESSFUL') {
                  return this.handleRequestWithToken(request,next)
                } else if(refreshStatus === 'FAILED') {
                  this.authentication.state.logout();
                  return throwError(() => Error('Token refresh failed after waiting'));
                }
                else
                {
                  return EMPTY;
                }
              }))
            }
          case 'IN PROGRESS':
            return this.authentication.state.refreshStatus$.pipe(
              filter(( status ) => status === 'SUCCESSFUL' || status === 'FAILED'),
              take(1),
              switchMap(updatedStatus => {
                if (updatedStatus === 'SUCCESSFUL') {
                  return this.handleRequestWithToken(request,next)
                } else {
                  this.authentication.state.logout();
                  return throwError(() => Error('Token refresh failed after waiting'));
                }
              })
            );
          default:
            return throwError(() => Error('Unexpected refresh token status'));
        }
      })
    );
  }

  private handleRequestWithToken(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.addTokenInHeader(request, ));
  }

addTokenInHeader(
    request: HttpRequest<any>,
): HttpRequest<any> {
    return request.clone({
       // setHeaders: { Authorization: 'Bearer ' + token, },
        withCredentials: true
    });
}
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];
